module.exports = __webpack_public_path__ + "static/media/stats-app.437b6682.png";